import { DataAttributeDefinitions } from 'scrivito'

import { pisaCompanyDataClass } from './Pisa/pisaCompanyDataClass'

const attributes: DataAttributeDefinitions = {}

export const Company = pisaCompanyDataClass(attributes)
